import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ilm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getToken = () => localStorage.getItem("ilm_token");

// Build a media URL for audio/image sources (uses query-param auth for <audio>/<img>)
export const mediaUrl = (obj, kind = "audio") => {
  if (!obj) return null;
  if (kind === "audio") {
    if (obj.is_external) return obj.external_url;
    if (obj.storage_path) return `${API}/files/${obj.storage_path}?auth=${getToken()}`;
    return obj.audio_url ? `${API}/files/${obj.audio_url}?auth=${getToken()}` : null;
  }
  // image (cover)
  if (obj.cover_url) return obj.cover_url;
  if (obj.cover) return `${API}/files/${obj.cover}?auth=${getToken()}`;
  return null;
};

export const avatarUrl = (user) => {
  if (!user) return null;
  if (user.photo_url) return user.photo_url;
  if (user.photo) return `${API}/files/${user.photo}?auth=${getToken()}`;
  return null;
};

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
